export default {
    list: {
        title: 'Equipo',
        subtitle: 'Gestiona los miembros del equipo',
        invite: 'Invitar Miembro',
        loading: 'Cargando equipo...',
        addMember: 'Añadir Miembro',
        allRoles: 'Todos los roles',
        allStatuses: 'Todos los estados',
        searchPlaceholder: 'Buscar por nombre o email...',
        rolePlaceholder: 'Filtrar por rol',
        statusPlaceholder: 'Filtrar por estado',
        description: 'Lista de los miembros de tu equipo',
        headers: {
            name: 'Nombre',
            email: 'Email',
            role: 'Rol',
            status: 'Estado',
            lastLogin: 'Último Inicio de Sesión',
            inviteDate: 'Fecha de Invitación',
            actions: 'Acciones',
        },
        noMembers: {
            title: 'No se encontraron miembros del equipo',
            message: 'Intenta modificar los filtros de búsqueda',
            emptyMessage: 'Comienza añadiendo tu primer miembro del equipo',
            addFirst: 'Añadir Primer Miembro',
        },
        modal: {
            addTitle: 'Añadir Miembro',
            editTitle: 'Editar Miembro',
            fields: {
                name: 'Nombre',
                namePlaceholder: 'Ingresa nombre',
                email: 'Email',
                emailPlaceholder: 'nombre@empresa.com',
                role: 'Rol',
                rolePlaceholder: 'Selecciona rol',
                status: 'Estado',
                statusPlaceholder: 'Selecciona estado',
            },
            cancel: 'Cancelar',
            save: 'Guardar',
            create: 'Crear',
        },
        statusLabels: {
            active: 'Activo',
            inactive: 'Inactivo',
        },
        never: 'Nunca',
        confirmDelete: '¿Estás seguro de que quieres eliminar este miembro del equipo?',
    },
};

